<div class="row survey_form survey-form-group">
  <div
    *ngFor="let question of advanceTargetingQualifications; let i = index"
    class="col-md-4 col-lg-3 form-group"
  >
    <div class="btn_close">
      <button
        class="btn adv-button"
        (click)="openAdvanceTargetingModal(question)"
      >
        <div>{{ question.qualification_name }}</div>
      </button>
      <div (click)="deleteAdvanceTargetingQuestion(i)" class="close-icon">
        <i class="fa fa-window-close" aria-hidden="true"></i>
      </div>
    </div>
    <ps-ui-advance-targeting-quotas
      *ngIf="question.isRangeType === 0 || question.question_type !== 'range'"
      [complete]="complete"
      [qualification]="question"
      [quotas]="question.quotas"
      [flexible]="question.flexible"
      [isQlcLiveSurvey]="isQlcLiveSurvey"
      (quotaChanged)="updateQuotas($event)"
      [hasNestedGroup]="hasNestedGroup"
    ></ps-ui-advance-targeting-quotas>
  </div>
  <ng-container *ngIf="showAllQualifications">
    <div class="col-md-4 col-lg-3 form-group">
      <button class="btn adv-button" (click)="openAdvanceTargetingModal()">
        <div>+ Add Definition</div>
      </button>
    </div>
    <ng-container *ngIf="advanceTargetingButtons.length">
      <div
        *ngFor="let button of advanceTargetingButtons; let index = index"
        class="col-md-4 col-lg-3 form-group"
      >
        <button class="btn adv-button adv-disabled" disabled>
          <div>+ Add Definition</div>
        </button>
      </div>
    </ng-container>
  </ng-container>
</div>
